// extracted by mini-css-extract-plugin
export default {"accountSummaryTitle":"HeaderSubHeader_accountSummaryTitle__D1epM","accountSummarySubTitle":"HeaderSubHeader_accountSummarySubTitle__lzC7y"};